
import MiniMainCard from '../MiniMainCard';

const MainCard = ({ MainTitle, data, status }) => {

    const newData = data && typeof data === 'object'
        ? Object.fromEntries(Object.entries(data).filter(([key]) => key !== 'deviceType'))
        : null;


    return (
        <div className={`w-full h-48 md:h-48 md:w-72 2xl:h-56 2xl:w-96 p-4 text-[12px] md:text-[12px] 2xl:text-[14px] border-2 border-dividerLines ${status === 'Not Supported' ? 'bg-gray-300' : 'bg-secondaryBg'} rounded-md`}>
            {MainTitle ? (
                <>
                    <div className=' flex justify-between items-center'>
                        <span className='capitalize font-bold text-[14px] 2xl:text-base'>
                            {MainTitle}
                        </span>
                        {status && (
                            <div className='text-labels text-center text-[10px] 2xl:text-[12px] font-semibold max-w-fit bg-accent_2 px-2 py-0.5 rounded-xl'>
                                <span>{status}</span>
                            </div>
                        )}
                    </div>
                </>
            )
                : '--'
            }
            <hr className=" my-2 h-[1px] border-t-0 bg-dividerLines " />
            <MiniMainCard
                miniCardData={newData}
            />
        </div >
    )
}

// Skip prop validation by setting propTypes to null
MainCard.propTypes = null;

export default MainCard